module.exports = __webpack_public_path__ + "img/transport.948160a3.svg";